import React from 'react';
import Image from 'next/image';
import Link from '../Link';
import styles from './styles.module.scss';

type ItemTematicaProps = {
    data: any
}

const ItemTematica = (props: ItemTematicaProps) => {

  const data = props.data;

  return (<>
    <Link href={`/tienda?tematica=${data.attributes?.slug}`}>
      <div className={styles.item}>
        <Image
          className={styles.foto}
          src={data.attributes?.portada?.data?.attributes?.url || "https://dummyimage.com/220x220/000000/ffffff"}
          alt={data.attributes?.nombre || "Temática We Celebrate!"}
          width={220}
          height={220}
        />
        <p>{data.attributes.nombre}</p>
      </div>
    </Link>
  </>);
};

export default ItemTematica;
